import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthServiceGuest } from './../services/AuthServiceGuest';
import { Router } from '@angular/router';
import { Observable, BehaviorSubject, AsyncSubject, of } from 'rxjs';


import * as _ from 'lodash';
import { CurrentUser } from '../dataTypes/CurrentUser';

@Injectable()
export class CanActivateViaAuthGuard implements CanActivate {

  public _user: CurrentUser;

  constructor(private _AuthService: AuthServiceGuest, private _router: Router) {

  }

  canActivate(route, state): Observable<boolean> {

    const self = this;
    if (!this._AuthService.isLoggedInGuests()) {
      window.location.replace('/login');
      return of(false);
    }

    else {

      self._user = self._AuthService.getUserInfo();
      if (self._router.url.startsWith('/guest')) {

        if (self._user.visibiltyPermissions === 1 || self._user.visibiltyPermissions === 0) {
          return of(true);
        }
        else return of(false);
      }
      else if (self._router.url.startsWith('/subscriber')) {

        if(self._user.visibiltyPermissions === 2 || self._user.visibiltyPermissions === 0) {
          return of(true);
        }
        else return of(false);
     
      }
      
      return of(true);
    }
  }
}
